import { Component, inject, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { OpportunitySnapshotsService } from '../../services/opportunity-snapshots.service';
import { SurplusLinesExistingCoverage, SurplusLinesPlanDesign, SurplusLinesPlanDesignsRequest } from '../../models/surplus-lines-plan-design.model';

@Component({
  selector: 'app-retirement-contribution',
  standalone: false,
  templateUrl: './retirement-contribution.component.html',
  styleUrl: '../../../assets/css/HighLimitsDialogs.css'
})
export class RetirementContributionComponent implements OnInit {
  readonly dialogRef = inject(MatDialogRef<RetirementContributionComponent>);
  RCBAmount: string = '';
  RCBDuration: string = '';
  RCBDurationOptions: string[] = [];
  RCBAmountOptions: string[] = [];
  monthlyBenefit: string = '';
  eliminationPeriod: string = '';
  quotesList: SurplusLinesPlanDesign[] = [];
  cost: string = '';
  planDesignRequest: SurplusLinesPlanDesignsRequest = new SurplusLinesPlanDesignsRequest();
  additionalPlanDesignRequest: SurplusLinesPlanDesignsRequest = new SurplusLinesPlanDesignsRequest();

  constructor(private _oss: OpportunitySnapshotsService) {
  }

  ngOnInit() {
    this.RCBDurationOptions = this.getRetirementContributionDurationOptions();
    this.RCBAmountOptions = this.getRetirementContributionAmountOptions();
    if(this.RCBAmount == ''){
      this.RCBAmount = this._oss.currentQuoteOptions?.RCBAmountDefault as string;
    }
    if(this.RCBDuration == ''){
      this.RCBDuration = this._oss.currentQuoteOptions?.RCBDurationDefault as string;
    }
    
    this.updateCost();
  }

  getRetirementContributionDurationOptions() {
    if (this._oss.currentQuoteOptions == null) {
      return [];
    }
    return this._oss.currentQuoteOptions.RCBDurationOptions.replaceAll('; ', ';').split(';');
  }

  getRetirementContributionAmountOptions() {
    if (this._oss.currentQuoteOptions == null) {
      return [];
    }
    return this._oss.currentQuoteOptions.RCBAmountOptions.replaceAll('; ', ';').split(';');
  }

  updateCost() {
    var existingCoverages: SurplusLinesExistingCoverage[] = [];

    this._oss.currentOpportunitySnapshot.OtherInsurance.forEach(element => {
      var existing = new SurplusLinesExistingCoverage();
      existing.Amount = element.MonthlyAmount;
      existing.Type = element.Type;
      existing.Payee = element.Paid;
      existingCoverages.push(existing);
    });

    this.additionalPlanDesignRequest.OpportunityId = this._oss.currentCompassOpportunity?.CompassId as number;
    this.additionalPlanDesignRequest.EarnedIncome = this._oss.currentApplicant.AnnualIncome;
    this.additionalPlanDesignRequest.ExistingCoverages = existingCoverages;
    this.additionalPlanDesignRequest.InsuredId = this._oss.currentCompassOpportunity?.InsuredId as number;
    this.additionalPlanDesignRequest.TTDMonthlyBenefit = this.monthlyBenefit;
    this.additionalPlanDesignRequest.EP = this.eliminationPeriod;
    this.additionalPlanDesignRequest.RCBAmount = this.RCBAmount;
    this.additionalPlanDesignRequest.RCBDuration = this.RCBDuration;
    this.additionalPlanDesignRequest.BenefitDuration = this._oss.currentQuoteOptions?.DurationDefault as string;

    this._oss.getQuote(this._oss.currentOpportunitySnapshot.OpportunityId, this.additionalPlanDesignRequest).subscribe(additionalQuote => {
      this._oss.getQuote(this._oss.currentOpportunitySnapshot.OpportunityId, this.planDesignRequest).subscribe(originalQuote => {
        this.cost = String(additionalQuote[0].YearOneCost - originalQuote[0].YearOneCost);
      });
    });
  }

  inclusion(){
    if(this._oss.currentQuoteOptions?.RCBInclusion == 'Y'){
      return true;
    }
    return false;
  }

  yes() {
    this.dialogRef.close({ RCBDuration: this.RCBDuration, RCBAmount: this.RCBAmount, cost: this.cost });
  }

  no() {
    this.dialogRef.close(false);
  }
}
